import { CompanyLinkUnionType, useUpdatePersonPrivateInfo } from '@api';

type HandleFavoriseCompanyLinkArgsType = {
  personId: string;
  linkId: string | null;
  type: CompanyLinkUnionType;
};

type UseCompanyLinkActionsReturnType = {
  handleFavoriseCompanyLink: (args: HandleFavoriseCompanyLinkArgsType) => void;
};

export const useFavoriseCompanyLink = (): UseCompanyLinkActionsReturnType => {
  const { mutate: mutateFavorise } = useUpdatePersonPrivateInfo();

  const handleFavoriseCompanyLink = (
    args: HandleFavoriseCompanyLinkArgsType
  ) => {
    if (!args.linkId) return;

    mutateFavorise({
      id: args.personId,
      data: {
        favoriteCompanyLink: {
          companyLinkId: args.linkId,
          type: args.type,
        },
      },
    });
  };

  return { handleFavoriseCompanyLink };
};
